import { BehaviorSubject } from 'rxjs';

export class Sortable {

  public sortField$: BehaviorSubject<[string, string]>

  constructor(defaultSortField = 'name', defaultSortDirection = 'asc') {
    this.sortField$ = new BehaviorSubject<[string, string]>([defaultSortField, defaultSortDirection]);
  }

  changeSort(field: string): void {
    const currentSort = this.sortField$.value;
    const nextSort: [string, string] = [field, 'desc'];
    if (currentSort?.[0] === field) {
      nextSort[1] = currentSort[1] === 'desc' ? 'asc' : 'desc';
    }
    this.sortField$.next(nextSort);
  }

  getSortIcon(field: string): string {
    return this.sortField$.value?.[0] === field
      ? this.sortField$.value[1] === 'asc' ? 'expand_less' : 'expand_more'
      : 'unfold_more';
  }
}
